import React, { useState, useEffect } from "react";
import Modal from "../../Components/Modal";
import Alert from "@mui/material/Alert";
import "../AddTeacher/AddTeacherForm.css";
import { addNoticeToDatabase } from "../../api/AddNotice/AddNotice";
import { toast } from "react-toastify";

const AddOrUpdateNoticeForm = ({
  isUpdateOn,
  isModalOpen,
  setIsModalOpen,
  DocId,
  handleNoticeAdded,
  handleNoticeUpdated,
}) => {
  const inticalData = {
    noticeTo: "",
    noticeSubject: "",
    noticeDescription: "",
  };
  const [noticeData, setNoticeData] = useState(inticalData);

  const [error, setError] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState(null);

  useEffect(() => {
    if (isModalOpen && isUpdateOn) {
      getnoticeData(DocId);
    }
  }, [isModalOpen, isUpdateOn]);

  const getnoticeData = async (DocId) => {};

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNoticeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {};

  const handleAdd = async () => {
    try {
      const response = await addNoticeToDatabase(noticeData);

      // Show a confirmation message
      if(response.status){
        setNoticeData(inticalData);
        setConfirmationMessage(null);
        setIsModalOpen(false);
        handleNoticeAdded();
        toast.success(response.message);
      }
      if(!response.status){
        setNoticeData(inticalData);
        setIsModalOpen(false);
        toast.error(response.message);
      }

    } catch (error) {
      console.error("Error updating subject data", error);
    }
  };

  if (!isModalOpen) return null;

  return (
    <Modal setShowModal={setIsModalOpen}>
      {error && (
        <Alert severity="error" style={{ marginBottom: "10px" }}>
          Fill all the fields
        </Alert>
      )}

      <h2 className="text-[20px] font-bold text-left bg-[#333333] text-white addTeacher-header">
        {isUpdateOn ? "Update Expense" : "Add Expense"}
      </h2>
      <div className="addTeacher-form">
        <form>
          <div className="addTeacher-main-form subject-form">
            <div className="form-first">
              <label className="block text-sm font-medium text-gray-700">
                Notice To*
              </label>
              <select
                type="text"
                name="noticeTo"
                value={noticeData.noticeTo}
                onChange={handleInputChange}
                className="mt-1 p-2 block w-full border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                <option value="">--- Select ---</option>
                <option value="Teacher">All Teacher</option>
                <option value="Student">All Student</option>
                <option value="Teacher&Student">All Teacher&Student</option>
                <option value="All Class">All Class</option>
              </select>
            </div>
            <div className="form-first">
              <label className="block text-sm font-medium text-gray-700">
                Notice Subject*
              </label>
              <input
                type="text"
                name="noticeSubject"
                value={noticeData.noticeSubject}
                onChange={handleInputChange}
                className="mt-1 p-2 block w-full border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="flex justify-between">
              <label className="block text-sm w-[200px] font-medium text-gray-700">
                Notice Description*
              </label>
              <textarea
                type="text"
                rows="6"
                name="noticeDescription"
                value={noticeData.noticeDescription}
                onChange={handleInputChange}
                className="mt-1 p-2 block w-[92%] border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
          </div>
          <div className="add-subject-btn addTeacher-buttons">
            <button
              type="button"
              onClick={isUpdateOn ? handleUpdate : handleAdd}
              className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white "
            >
              {isUpdateOn ? "Update" : "Add"}
            </button>
            <button
              type="button"
              onClick={() => {
                setNoticeData(inticalData);
                setIsModalOpen(false);
              }}
              className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white "
            >
              Close
            </button>
          </div>
        </form>
      </div>

      {confirmationMessage && (
        <div className="text-green-500 mt-4 text-center">
          {confirmationMessage}
        </div>
      )}
    </Modal>
  );
};

export default AddOrUpdateNoticeForm;
